var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"block"},[_c('div',{staticClass:"block__title"},[_vm._v("Search")]),_c('div',{staticClass:"block__element"},[_c('Search',{attrs:{"placeholder":'Busca un asistente'},on:{"input":_vm.handleInput}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }